module.exports = "/img/_/_/_/assets/images//headline.png?2944ae6ec90ea02831eea62fa9a9acb5";